'use client';
import { IRepository, ICommit } from '@/types';
import { IRepositoryBranch, IResourceDefinition } from '@/lib/repositoryBranchesApi';
import { useRouter } from 'next/navigation';
import { IRemoteWorkspace } from '@/lib/workspaces/workspaceApi';
import BranchWorkspaceSelector from '../BranchWorkspaceSelector';
import Tag from '@/ui/Tag';
import * as Icon from '@/ui/Icon';
const BranchNavigator: React.FC<{
  path: string[];
  repository: IRepository;
  resourceType: 'dir' | 'file' | 'commits';
  resource?: IResourceDefinition | null;
  branches: IRepositoryBranch[];
  workspace?: IRemoteWorkspace;
  workspaces: IRemoteWorkspace[];
  children?: React.ReactNode;
  mode?: 'view' | 'edit';
}> = ({ repository, resourceType, resource, branches = [], workspaces = [], path, workspace, children, mode }) => {
  const router = useRouter();

  type SelectionBase = { type: 'branch' | 'workspace' | 'commit'; name: string };

  type Selection = SelectionBase | undefined;

  const workspaceSelection: Selection = workspace
    ? { type: 'workspace', name: workspace?.name || workspace?.id }
    : undefined;

  const branchSelection: Selection = resource?.branch ? { type: 'branch', name: resource?.branch?.name } : undefined;

  const commitSelection: Selection = resource?.commit ? { type: 'commit', name: resource?.commit?.id } : undefined;

  const activeCommit = !workspace ? resource?.commit : undefined;

  const onSelectionChange = (selection: {
    type: 'branch' | 'workspace' | 'commit';
    entity: IRepositoryBranch | IRemoteWorkspace | ICommit;
  }) => {
    if (selection.type === 'workspace') {
      const workspace = selection.entity as IRemoteWorkspace;
      const url = `/${repository.namespace}/${repository.name}/workspaces/${workspace.id}//${resourceType}/${resource?.path}`;
      router.push(url);
      router.refresh();
    } else if (selection.type === 'branch') {
      const branch = selection.entity as IRepositoryBranch;
      const url = `/${repository.namespace}/${repository.name}/${resourceType}/${branch.name}/${resource?.path}`;
      router.push(url);
      router.refresh();
    } else if (selection.type === 'commit') {
      const commit = selection.entity as ICommit;
      const url = `/${repository.namespace}/${repository.name}/${resourceType}/${commit.id}/${resource?.path}`;
      router.push(url);
      router.refresh();
    }
  };

  if (mode === 'edit') {
    return (
      <div style={{ maxWidth: '280px' }}>
        <Tag variant="info">
          {branchSelection ? (
            <>
              <Icon.Branch />
              {branchSelection.name}
            </>
          ) : (
            <>
              <Icon.Commit />
              {commitSelection?.name}
            </>
          )}
        </Tag>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: '280px' }}>
      <BranchWorkspaceSelector
        branches={branches}
        workspaces={workspaces}
        selected={workspaceSelection || branchSelection || commitSelection}
        onChange={onSelectionChange}
        commit={activeCommit}
      />
    </div>
  );
};

export default BranchNavigator;
